var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 46,
    viewBox: "0 0 92 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.7341 26.7266C57.8441 27.5271 43.6117 28.2705 29.3222 28.8995C21.5486 29.2426 13.8323 29.5856 6.05877 29.5856C4.00107 29.5856 1.94338 28.3277 0 26.3263C23.3206 20.5511 47.2127 20.8942 71.6192 17.635C68.8185 13.9754 66.1321 11.4023 64.6459 8.20019C63.7314 6.19888 63.6171 2.36778 64.8746 1.167C66.1892 -0.0909695 70.3618 -0.262516 71.905 0.938271C78.5925 6.02732 85.0514 11.5738 90.9959 17.5206C92.2534 18.8357 92.139 23.5245 90.7672 25.0684C85.3944 31.2438 79.3928 36.9047 73.5055 42.6227C70.8762 45.1387 67.1609 46.9684 64.7603 43.2517C63.6171 41.4791 64.5888 37.4193 65.8463 35.1321C67.2752 32.4446 70.1331 30.5005 73.7913 26.7838L73.7341 26.7266Z",
    fill: "#017E84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow3);
export default __webpack_public_path__ + "static/media/arrow3.6e97104cc971e1c6e3884a2aefbe6fd4.svg";
export { ForwardRef as ReactComponent };